export default __webpack_public_path__ + "static/media/Snow.d75b99fa.mp4";